import { render } from "./UINumberInput.vue?vue&type=template&id=a6d32dac"
import script from "./UINumberInput.vue?vue&type=script&lang=ts"
export * from "./UINumberInput.vue?vue&type=script&lang=ts"
script.render = render

export default script